module.exports = __webpack_public_path__ + "static/media/16_plantilla_cuadrada_combo_simple_cp_stills_tetra_200_cepita_nar.fd420edb.png";